import * as api from "@/api/williams/welders";
import { queryKeys } from "../../queryKeys";
import { useInfiniteQuery } from "react-query";
import { WelderFilters } from "@/api/williams/welders";

const PAGE_SIZE = 100;

export function useWelderList(filters: Partial<WelderFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.welder.filter(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.getWelderList({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
  });
}
